import { ProductScreenshot } from 'components/ProductScreenshot';
import EventsLight from "../../../../contents/images/tutorials/nuxt-surveys/events-light.png";
import EventsDark from "../../../../contents/images/tutorials/nuxt-surveys/events-dark.png";
import ImgSurveyResultsLight from "../../../../contents/images/tutorials/nuxt-surveys/survey-results-light.png";
import ImgSurveyResultsDark from "../../../../contents/images/tutorials/nuxt-surveys/survey-results-dark.png";
import ImgSurveyTemplatesLight from "../../../../contents/images/tutorials/nuxt-surveys/survey-templates-light.png";
import ImgSurveyTemplatesDark from "../../../../contents/images/tutorials/nuxt-surveys/survey-templates-dark.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  EventsLight,
  EventsDark,
  ImgSurveyResultsLight,
  ImgSurveyResultsDark,
  ImgSurveyTemplatesLight,
  ImgSurveyTemplatesDark,
  React
};